import { Unit } from '../types';

export const formatUnit = (px: number | undefined, unit: Unit): string => {
  if (px === undefined || px === null || isNaN(px)) return '0';
  let value = px;
  switch (unit) {
    case 'mm': value = px / 3.779527559; break;
    case 'cm': value = px / 37.79527559; break;
    case 'in': value = px / 96; break;
    case 'pt': value = px * 0.75; break; // 1px = 0.75pt (since 96px = 72pt)
  }
  return Number.isInteger(value) ? value.toString() : value.toFixed(2);
};

export const parseUnit = (valueStr: string | number, unit: Unit): number => {
  const value = typeof valueStr === 'string' ? parseFloat(valueStr) : valueStr;
  if (isNaN(value)) return 0;
  switch (unit) {
    case 'mm': return value * 3.779527559;
    case 'cm': return value * 37.79527559;
    case 'in': return value * 96;
    case 'pt': return value / 0.75;
  }
};
